// extracted by mini-css-extract-plugin
export default {"listWrapper":"J0ehQle1","title":"FhYFnAHB","card":"W7TmcTcj","cardTitle":"C1zIWVSf","cardSubtitle":"gWt6z8uR","cardDate":"QCDnp7kC"};